/* src/app/shared/verification/components/phone-verification-steps/phone-verification-steps.component.scss */
.auth-without-login-verify-otp {
  padding: 40px;
  background: #FFFFFF;
  box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 40px auto;
  line-height: 1.4;
}
.auth-without-login-verify-otp .verification-notify-step .verify-mobile-number {
  padding: 0;
}
.auth-without-login-verify-otp .verification-notify-step .verify-mobile-number .verification-code-wrapper {
  margin: 0 !important;
}
.auth-without-login-verify-otp .verification-code-wrapper {
  margin: 0 auto;
  padding: 0;
  background: transparent;
  box-shadow: none;
}
/*# sourceMappingURL=phone-verification-steps.component-7XVFNIGA.css.map */
